@import "src/helpers/ScreenSizes.scss"; //imports mixins for different screen sizes

.loginScreen {
  @include windowSizes();
  border: 1px solid #c5c5ca;
  border-radius: 20px;
  background-color: white;
  overflow: auto;
}

.closeButtonContainer {
  display: flex;
  justify-content: flex-end;
  padding: 21px 21px 0 0;
}

.loginScreenContent {
  padding: 20px 72px 0px 72px;
  font-family: "Inter";
  font-style: normal;
  color: #39393a;

  @include medium() {
    padding: 20px 26px 0px 26px;
  }

  @include small() {
    padding: 20px 18px 0px 18px;
  }
}

.greetingText {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}

.descriptionText {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  font-feature-settings: "liga" off;
  margin: 8px 0 24px 0;
}

.horizontalMarkContainer {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  justify-content: center;

  margin: 0 0 24px 0;
}

.infoMessage {
  margin: 0 0 24px 0;
}

.continueButtonContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 32px 0 0 0;
  height: 100%;

  position: -webkit-sticky; /* Safari */
  position: sticky;
  bottom: 0px;
  background-color: white;
}

.continueButton {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  background: #16182b;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  width: 376px;
  height: 48px;

  @include small {
    width: 100%;
  }
}

.newAccountLink {
  display: flex;
  justify-content: center;
  margin: 24px 0 40px 0;
}
